import { makeStyles } from '@lifeomic/chroma-react/styles';
import { PlotContainer } from '@lifeomic/phc-web-toolkit/src/components/Plot/PlotContainer';
import * as React from 'react';
import Plot from 'react-plotly.js';
import useWindowSize from '@lifeomic/chroma-react/hooks/events/useWindowSize';

const plotHeight = 800;

const useStyles = makeStyles(theme => ({
  root: {
    height: plotHeight,
  },
  plot: {
    width: '100%',
    height: '100%',
  },
}));

export const BarChart = ({ data, isLoading, xtitle, ytitle }) => {
  const classes = useStyles({});

  const { width } = useWindowSize();

  return (
    <PlotContainer
      className={classes.root}
      data-testid="bar-chart"
      isLoading={isLoading}
    >
      <Plot
        className={classes.plot}
        data={data || []}
        layout={{
          hovermode: 'x unified',
          height: plotHeight,
          width: width - 100,
          yaxis: {
            title: {
              text: `<b>${ytitle}</b>`,
              family:
                '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
            },
          },
          xaxis: {
            tickangle: 45,
            automargin: true,
            title: {
              text: `<b>${xtitle}</b>`,
              family:
                '"Lato", Helvetica, Roboto, Arial, "Lucida Grande", sans-serif',
            },
          },
        }}
      />
    </PlotContainer>
  );
};
